import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {PermissionContextService} from '../../service/context/permission-context.service';

type NavItem = { link?: string; permission?: string[]; children?: NavItem[] };

const flatten = (items: NavItem[] = []): NavItem[] =>
  items.flatMap(i => (i.children ? flatten(i.children) : [i]));

function resolveLanding(
  route: ActivatedRouteSnapshot,
  perms: PermissionContextService,
  groups: ('items' | 'settingsItems' | 'sdrfItems')[] = ['items', 'settingsItems', 'sdrfItems']
): string | null {
  const sidebar = route.pathFromRoot.map(r => r.data?.['sidebar']).find(Boolean) ?? {};
  const candidates = flatten(groups.flatMap(g => sidebar[g] ?? []));
  const target = candidates.find(i => i.link && i.permission?.length && perms.hasAny(i.permission));
  return target?.link ?? null;
}

export const landingGuard: CanActivateFn = (route) => {
  const perms = inject(PermissionContextService);
  return inject(Router).createUrlTree([resolveLanding(route, perms) ?? '/welcome']);
};

export const settingsLandingGuard: CanActivateFn = (route) => {
  const perms = inject(PermissionContextService);
  return inject(Router).createUrlTree([resolveLanding(route, perms, ['settingsItems']) ?? '/']);
};

export const welcomeGuard: CanActivateFn = (route) => {
  const perms = inject(PermissionContextService);
  return resolveLanding(route, perms) ? inject(Router).createUrlTree(['/']) : true;
};
